// extracted by mini-css-extract-plugin
export default {"container":"container__7e55ac1d","products_wrapper":"products_wrapper__7e55ac1d"};